import { Box, Button, Grid, Typography, useTheme } from '@mui/material'
import { ITender } from 'types/tender'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { formatTimeStampToDate } from 'hooks/date/formattedTime'
import { ECommitteeEvaluationStatus } from 'types/committee-evaluation'

type Props = {
  tender: ITender
  onConfirm: () => void
  onReject: () => void
  status: string
}

export const CommitteeEvaluationDetailsHeader = ({
  tender,
  onConfirm,
  onReject,
  status,
}: Props) => {
  const { t } = useTranslation()
  const theme = useTheme()

  const navigate = useNavigate()

  const handleConfirm = () => {
    onConfirm()
  }

  const handleReject = () => {
    onReject()
  }

  return (
    <Box
      bgcolor="white"
      borderRadius={2}
      position="sticky"
      top={-16}
      mr={-1}
      ml={-1}
      zIndex={2}
      my={1}
    >
      <Box
        pb={1.5}
        bgcolor={`${theme.palette.primary.main}22`}
        px={1.5}
        borderRadius={2}
        boxShadow="0 0 20px 2px #c0baba;"
      >
        <Grid container spacing={1.5}>
          <Grid alignItems="center" item xs={3}>
            <Typography>
              {t(`${tender.method}_title`)} #{tender.id}
            </Typography>
          </Grid>
          <Grid alignItems="center" item xs={3}>
            <Typography>
              {t('startDate')}:{' '}
              {tender.startTime && formatTimeStampToDate(tender.startTime)}
            </Typography>
          </Grid>
          <Grid alignItems="center" item xs={3}>
            <Typography>{t(`tender-status-${tender.status}`)}</Typography>
          </Grid>
          <Grid alignItems="center" item xs={3}>
            <Box display="flex" justifyContent="flex-end">
              {status && status === ECommitteeEvaluationStatus.PENDING && (
                <>
                  <Button
                    onClick={handleConfirm}
                    size="small"
                    sx={{ mr: 2 }}
                    variant="contained"
                    style={{ color: '#fff', backgroundColor: 'rgb(3, 34, 76)' }}
                  >
                    {t('confirm')}
                  </Button>
                  <Button
                    onClick={handleReject}
                    size="small"
                    variant="contained"
                    style={{ color: '#fff', backgroundColor: 'rgb(3, 34, 76)' }}
                    sx={{
                      backgroundColor: '#f14433',
                      mr: 2,
                      '&:hover': { background: '#f14433' },
                    }}
                  >
                    {t('reject')}
                  </Button>
                </>
              )}
              <Button onClick={() => navigate(-1)} size="small" variant="outlined">
                {t('back')}
              </Button>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </Box>
  )
}
